"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorFallBackComponent;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _GlobalErrorHandler = _interopRequireDefault(require("../../utils/GlobalErrorHandler"));
// NOTE: real err should be logged somewhere
function ErrorFallBackComponent() {
  return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Alert, {
    type: "error",
    id: "cscn-general-error",
    qaId: "cscn-general-error"
  }, _GlobalErrorHandler.default.getErrorMessage('serverError'));
}